/**
 * Типизированный доступ к REACT_APP_*-переменным.
 *
 * CRA: env-переменные «впекаются» в build-time. Дефолт задаётся ЗДЕСЬ и
 * только здесь — Dockerfile ARG и CI передают значения исключительно для
 * переопределения, пустой ARG трактуется как «не задано». Раньше те же
 * дефолты были продублированы в Dockerfile и в глобальных переменных
 * .gitlab-ci.yml.
 *
 * У realm и clientId дефолта НЕТ намеренно: они различаются на каждом
 * стенде, и любое значение по умолчанию означало бы, что стенд с потерянной
 * переменной молча соберётся с чужим Keycloak (раньше — с ЗКО: витрина
 * поднималась и логинила пользователей через чужой realm, без единой
 * ошибки). Пусто → CI роняет сборку, а рантайм пишет причину в консоль.
 *
 * Значения стендов — `deploy/env/<region>[-prod].env`, см. job `build`
 * в .gitlab-ci.yml.
 */

const fromEnv = (key: string, fallback: string): string => {
  const value = process.env[key];
  // Пустая строка = «не задано»: docker build без --build-arg прокидывает
  // ARG-пустышки как '', и `??` их не отсекает.
  return value != null && value !== '' ? value : fallback;
};

export const env = {
  // Одинаково на всех стендах: путь относительный, до бэкенда доводит nginx
  // (frontend/nginx/default.conf.template) или dev-прокси (setupProxy.js).
  apiBaseUrl: fromEnv('REACT_APP_API_BASE_URL', '/api'),
  // Один Keycloak на все регионы; переопределяется, если он переедет.
  keycloakUrl: fromEnv('REACT_APP_KEYCLOAK_URL', 'https://vpn.csi.kz/auth'),
  // Per-stand, без дефолта — см. шапку файла.
  keycloakRealm: fromEnv('REACT_APP_KEYCLOAK_REALM', ''),
  keycloakClientId: fromEnv('REACT_APP_KEYCLOAK_CLIENT_ID', ''),
} as const;

/** Собран ли бандл с конфигом стенда (realm/clientId непустые). */
export const isKeycloakConfigured = (): boolean =>
  env.keycloakRealm !== '' && env.keycloakClientId !== '';
